<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="metaMsgTemplateModal"
  aria-hidden="true" [config]="{ignoreBackdropClick: true, keyboard: false}" (onShown)="onShown()">
  <div class="modal-dialog modal-xl">
    <mat-progress-bar *ngIf="isBusy" mode="indeterminate"></mat-progress-bar>
    <div class="card modal-content" *ngIf="form">
      <form (ngSubmit)="save()" [formGroup]="form">
        <div class="header">
          <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h2>Template de Mensagem</h2>
        </div>
        <div class="modal-body">
          <div class="alert alert-danger" *ngIf="errors.length > 0">
            <h3>Oops! Algo deu errado:</h3>
            <ul>
              <li *ngFor="let error of errors">{{ error }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-8">
              <mat-form-field>
                <mat-label>Nome</mat-label>
                <input matInput formControlName="name" type="text" maxlength="512" />
                <mat-hint align="end">Somente letras minúsculas, números e underscore</mat-hint>
                <mat-error>Use apenas letras minúsculas, números e underscores.</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Idioma</mat-label>
                <input matInput formControlName="language" type="text" maxlength="10" readonly />
                <mat-hint align="end">Ex: pt_BR</mat-hint>
                <mat-error>Informe um idioma válido.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Categoria</mat-label>
                <mat-select formControlName="categoria">
                  <mat-option *ngFor="let item of typesService.metaMsgTemplateCategoryTypes" [value]="item.value">
                    {{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                  <mat-option *ngFor="let item of typesService.metaMsgTemplateStatusTypes" [value]="item.value">
                    {{item.text}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>WABA ID</mat-label>
                <input matInput formControlName="whatsAppBusinessAccountId" type="text" maxlength="100" readonly />
                <mat-hint align="end">Preenchido pela sincronização Meta</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Meta Template ID</mat-label>
                <input matInput formControlName="metaTemplateId" type="text" maxlength="100" readonly />
                <mat-hint align="end">Gerado pela Meta</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Qualidade</mat-label>
                <input matInput formControlName="qualityScore" type="text" maxlength="50" readonly />
                <mat-hint align="end">Máx 50 caracteres</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Enviado em</mat-label>
                <input matInput formControlName="submittedAt" type="datetime-local" readonly />
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-label>Atualizado na Meta em</mat-label>
                <input matInput formControlName="metaUpdatedAt" type="datetime-local" readonly />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Motivo de rejeição</mat-label>
                <textarea matInput formControlName="rejectionReason" rows="3" maxlength="500" readonly></textarea>
                <mat-hint align="end">Máx 500 caracteres</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <br>
          <mat-accordion multi>
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Componentes
                </mat-panel-title>
              </mat-expansion-panel-header>
              <app-meta-msg-template-component (autoSave)="autoSave()" [metaMsgTemplateId]="form.value.id"
                [templateConfirmacaoPresenca]="isTemplateConfirmacaoPresenca">
              </app-meta-msg-template-component>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Botões
                </mat-panel-title>
              </mat-expansion-panel-header>
              <app-meta-msg-template-button (autoSave)="autoSave()" [metaMsgTemplateId]="form.value.id">
              </app-meta-msg-template-button>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </form>
      <div class="footer">
        <mat-slide-toggle [(ngModel)]="multiCreate" color="primary" *ngIf="newItem" style="margin-right: 10px;">
          Continuar Incluindo
        </mat-slide-toggle>
        <button mat-flat-button [disabled]="!form.valid || isBusy" type="submit" (click)="save()" color="primary"
          class="button-row">
          <span> Salvar</span>
        </button>
        <button mat-stroked-button type="button" [routerLink]="" (click)="close()" class="button-row">
          <span> Cancelar</span>
        </button>
      </div>
    </div>
  </div>
</div>
